import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Row, Card } from 'antd';
import { elipsis } from 'shared/utils/StringUtil';
import { get } from 'lodash';

import OneRowData from 'components/OneRowData';

import text from './Home.page.translation';

export default class Home extends Component {
  renderRowData(data, key) {
    return <OneRowData key={key} data={data[key]} />;
  }

  _renderLeftData = () => {
    const {
      me,
      intl: { formatMessage },
    } = this.props;
    let listLeftData = [];
    let listLeftSection = '';

    const firstname = get(me, 'firstname', '');
    const lastname = get(me, 'lastname', '');
    const fullname = `${firstname} ${lastname}`;
    const address = get(me, 'organization_details.address', '-');
    const owner = get(me, 'organization_details.owner_fullname', '-');
    const orgId = get(me, 'organization_details.organization_id', '-');

    listLeftData = [
      {
        label: formatMessage(text.orgId),
        value: orgId,
      },
      {
        label: formatMessage(text.name),
        value: fullname,
      },
      {
        label: formatMessage(text.address),
        value: address,
        elipsis: elipsis(address, 30),
      },
      {
        label: formatMessage(text.owner),
        value: owner,
      },
    ];

    listLeftSection = Object.keys(listLeftData).map(
      this.renderRowData.bind(this, listLeftData),
    );

    return (
      <Card.Grid className="card-grid-style minH210">
        {listLeftSection}
      </Card.Grid>
    );
  };

  _renderRightData = () => {
    const {
      me,
      intl: { formatMessage },
    } = this.props;
    let listRightSection = '';
    if (me) {
      const email = get(me, 'user_details.email', '');
      const roles = get(me, 'user_details.user_role', []);
      let userRole = '-';
      if (roles.length) {
        roles.forEach((role, index) => {
          if (index > 0) {
            userRole += `, ${role.name}`;
          } else {
            userRole = role.name;
          }
        });
      }

      const listRightData = [
        {
          label: formatMessage(text.email),
          value: email,
        },
        {
          label: formatMessage(text.role),
          value: userRole,
          elipsis: elipsis(userRole, 30),
        },
        {
          label: formatMessage(text.username),
          value: email,
        },
      ];

      listRightSection = Object.keys(listRightData).map(
        this.renderRowData.bind(this, listRightData),
      );
    }
    return (
      <Card.Grid className="card-grid-style minH210">
        {listRightSection}
      </Card.Grid>
    );
  };

  render() {
    const customStyle = {
      fontSize: '24px',
      paddingLeft: '0px',
    };
    const {
      intl: { formatMessage },
    } = this.props;
    return (
      <div className="main-content">
        <div className="breadcrumb-wrapper">
          <span>{formatMessage(text.home)}</span>
        </div>

        <div className="white-box-wrapper">
          <Card
            title={formatMessage(text.title)}
            headStyle={customStyle}
            bordered={false}
          >
            <Row type="flex">
              {this._renderLeftData()}
              {this._renderRightData()}
            </Row>
          </Card>
        </div>
      </div>
    );
  }
}

Home.propTypes = {
  me: PropTypes.object,
  intl: PropTypes.object.isRequired,
};
